export const FETCH_STATUS_NONE = 'none';
export const FETCH_STATUS_PENDING = 'pending';
export const FETCH_STATUS_SUCCESS = 'success';
export const FETCH_STATUS_FAILED = 'failed';
export const FETCH_STATUS_ABORTED = 'aborted';

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const fetchStatus = {
  NONE: FETCH_STATUS_NONE,
  PENDING: FETCH_STATUS_PENDING,
  SUCCESS: FETCH_STATUS_SUCCESS,
  FAILED: FETCH_STATUS_FAILED,
  ABORTED: FETCH_STATUS_ABORTED,
} as const;

export type FetchStatus = (typeof fetchStatus)[keyof typeof fetchStatus];

export const isFetchStatusNone = (...args: (string | FetchStatus)[]) =>
  args.every((status) => status === FETCH_STATUS_NONE);
export const isFetchStatusPending = (...args: (string | FetchStatus)[]) =>
  args.some((status) => status === FETCH_STATUS_PENDING);
export const isFetchStatusSuccess = (...args: (string | FetchStatus)[]) =>
  args.every((status) => status === FETCH_STATUS_SUCCESS);
export const isFetchStatusFailed = (...args: (string | FetchStatus)[]) =>
  args.some((status) => status === FETCH_STATUS_FAILED);
export const isFetchStatusAborted = (...args: (string | FetchStatus)[]) =>
  args.some((status) => status === FETCH_STATUS_ABORTED);

export const isFetchStatusCompleted = (...args: (string | FetchStatus)[]) => {
  return args.every((status) => status === FETCH_STATUS_SUCCESS || status === FETCH_STATUS_FAILED);
};

export const isFetchStatus = (status: string | FetchStatus): status is FetchStatus => {
  return (
    status === FETCH_STATUS_NONE ||
    status === FETCH_STATUS_PENDING ||
    status === FETCH_STATUS_SUCCESS ||
    status === FETCH_STATUS_FAILED ||
    status === FETCH_STATUS_ABORTED
  );
};
